/**
 * Simple global store for chart dropdown selections.
 * Screen charts write to this on change.
 * Print charts read from this before PDF capture.
 */

const selections: Record<string, any> = {};

export function setChartSelection(chartId: string, value: any) {
  selections[chartId] = value;
}

export function getChartSelection(chartId: string): any {
  return selections[chartId] ?? null;
}

/**
 * Dispatch this event to tell print charts to sync their state
 * from the global store. Call this before PDF capture.
 */
export function triggerSyncSelections() {
  window.dispatchEvent(new Event("pdf-sync-selections"));
}
